export const width=1920;export const height=946.833855799373;export default{width:width,height:height};